import { ReactComponent as RemoveIcon } from "../../../assets/icons/x.svg";
import chipStyles from "../../../styles/UI/chips.module.css";

const ColorChip = ({
  text,
  color,
  onRemove,
  classes,
}: {
  text: string;
  color?: string;
  onRemove?: () => void;
  classes?: string;
}) => {
  return (
    <div
      className={`${chipStyles.colorChip} ${classes || ""}`}
      style={{ backgroundColor: color || "var(--col-interaction-tertiary)" }}
    >
      {text}
      {onRemove && <RemoveIcon onClick={onRemove} />}
    </div>
  );
};

export default ColorChip;
